(() => {
  const pdfs = new Map();

  function connect(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const get = (key) => root.querySelector(`[data-er-${key}]`);
    const dialog = root.querySelector('dialog');
    const frame = get('page');
    const canvas = frame.querySelector('canvas');
    const status = get('status');
    const prev = get('prev');
    const next = get('next');
    const chapter = get('chapter');
    const first = Number(root.dataset.first) || 1;
    let last = Number(root.dataset.last);
    let current = first;
    let pdf;
    let busy = false;

    async function draw(number) {
      if (!pdf || busy || number < first || number > last) return;
      busy = true;
      prev.disabled = next.disabled = true;
      if (chapter) chapter.disabled = true;
      status.textContent = '';
      try {
        const page = await pdf.getPage(number);
        const width = frame.clientWidth;
        const density = Math.min(devicePixelRatio || 1, 2);
        const viewport = page.getViewport({ scale: width * density / page.getViewport({ scale: 1 }).width });
        canvas.width = Math.ceil(viewport.width);
        canvas.height = Math.ceil(viewport.height);
        canvas.style.width = `${width}px`;
        await page.render({ canvas, viewport }).promise;
        current = number;
        frame.scrollTop = 0;
        get('count').textContent = `${current - first + 1} / ${last - first + 1}`;
        if (chapter) chapter.value = current >= 35 ? '35' : current >= 20 ? '20' : '1';
      } catch {
        status.textContent = root.dataset.error;
      } finally {
        busy = false;
        prev.disabled = current <= first;
        next.disabled = current >= last;
        if (chapter) chapter.disabled = false;
      }
    }

    get('open').addEventListener('click', async () => {
      dialog.showModal();
      if (pdf) {
        await draw(current);
        return;
      }
      status.textContent = root.dataset.loading;
      const url = new URL(root.dataset.pdf, location.href).href;
      try {
        if (!pdfs.has(url)) {
          pdfs.set(url, import(new URL(root.dataset.module, location.href).href).then((library) => {
            library.GlobalWorkerOptions.workerSrc = new URL(root.dataset.worker, location.href).href;
            return library.getDocument({ url, isEvalSupported: false, enableXfa: false }).promise;
          }));
        }
        const document = await pdfs.get(url);
        if (!dialog.open) return;
        pdf = document;
        last = Math.min(last || pdf.numPages, pdf.numPages);
        get('viewer').hidden = false;
        await draw(current);
      } catch {
        pdfs.delete(url);
        status.textContent = root.dataset.error;
      }
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
    prev.addEventListener('click', () => draw(current - 1));
    next.addEventListener('click', () => draw(current + 1));
    chapter?.addEventListener('change', () => draw(Number(chapter.value)));
  }

  document.querySelectorAll('[data-er-report]').forEach(connect);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-er-report]').forEach(connect));
})();
